import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          The milk delivery tracker
        </p>
      </header>
    </div>
  );
}

export default App;
